import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useLayoutEffect, useRef, useState } from "react";

interface ProductSpecsProps {
  specs: any;
  htmlContent: string;
}

const ProductSpecs: React.FC<ProductSpecsProps> = (props) => {
  const contentRef = useRef<HTMLDivElement>(null);
  var productData = JSON.parse(props.specs);
  productData = {
    ...productData,
    "Mô tả sản phẩm": { htmlContent: props.htmlContent },
  };
  // Lấy danh sách các keys (categories)
  var categories = Object.keys(productData);

  // State để quản lý accordion nào đang mở
  const [expanded, setExpanded] = useState(categories[0]); // Mặc định mở accordion đầu tiên

  const handleChange = (panel: any) => (event: any, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  useLayoutEffect(() => {
    if (contentRef.current) {
      const images = contentRef.current.querySelectorAll("img");
      images.forEach((img) => {
        // Xóa tất cả inline styles trước
        img.removeAttribute("style");

        // Thêm class mới
        img.classList.add("w-full", "h-auto", "max-w-full", "block");
      });
    }
  }, []);

  return (
    <div className=" bg-white rounded-xl p-5 mt-5 shadow-md">
      <div className="space-y-4">
        {categories.map((category, index) => (
          <Accordion
            key={category}
            expanded={expanded === category}
            onChange={handleChange(category)}
            className="shadow-lg rounded-lg overflow-hidden transition-all duration-300"
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              className={`bg-gradient-to-r from-primary_blue to-white  hover:from-primary_gray hover:to-primary_blue transition-all duration-300 ${
                expanded === category ? "primary_blue" : ""
              }`}
            >
              <Typography className="!text-white !font-semibold text-lg ">
                {category}
              </Typography>
            </AccordionSummary>

            <AccordionDetails className="p-0">
              <TableContainer component={Paper} className="shadow-none">
                <Table>
                  <TableBody>
                    {Object.entries(productData[category]).map(
                      ([key, value]) => (
                        <TableRow
                          key={key}
                          className="hover:bg-gray-50 transition-colors duration-200"
                        >
                          <TableCell
                            className={
                              key === "htmlContent"
                                ? "!hidden"
                                : "font-medium text-gray-700 border-r"
                            }
                          >
                            {key}
                          </TableCell>
                          <TableCell className="text-gray-600">
                            {key === "htmlContent" ? (
                              <div
                                ref={contentRef}
                                dangerouslySetInnerHTML={{
                                  __html: value as string,
                                }}
                              />
                            ) : (
                              String(value)
                            )}
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
};

export default ProductSpecs;
